/**
 * A single small leaf — the unit the generator scatters along branches.
 *
 * Drawn in its own coordinate space with the stem base at the origin and
 * the blade reaching up-and-over toward the tip. `BranchField` clones it
 * per instance; `generate.ts` places each one by transform (rotate the
 * base→tip axis onto a screen direction, scale, and optionally mirror so
 * the curve faces the right way for the side it sits on).
 *
 * Shape: a curved, money-plant / vine leaf — a swept teardrop whose
 * midrib bows to one side and hooks to a soft point, rather than a stiff
 * symmetric almond. One flat silhouette (no inner vein); it tints with
 * the theme via the `koko-leaf` class (fill: var(--branch-ink), see
 * studio.css).
 */

/** Stem base, where the leaf attaches to a branch. */
export const FOLIAGE_ANCHOR = { x: 0, y: 0 };
/**
 * Screen angle of the base→tip axis (the leaf's natural tip sits near
 * (3, -24), so the axis leans slightly off straight-up). `generate.ts`
 * rotates this onto the desired direction.
 */
export const FOLIAGE_AXIS_DEG = -83;
/** Natural base→tip length, so callers can reason about on-screen size. */
export const FOLIAGE_AXIS_LEN = 24;

// A leaf with a short petiole (so it visibly attaches to the branch)
// sweeping up into a blade that curves to +x (the right): convex right
// edge, concave left edge cupping back, tip hooking softly to a point
// near (3, -24). Mirrored per-instance for left-side leaves.
export const FOLIAGE_MARKUP =
  '<path class="koko-leaf" d="' +
  "M 0 0 C 0.4 -1.5 0.8 -3 0.9 -4.5 C 2.5 -7 6.5 -10 7 -14.5 " +
  "C 7.3 -18 5.5 -21.5 3 -24 C 1 -22 -0.6 -16 -1.3 -11 " +
  "C -1.6 -7.5 -1.1 -5.5 -0.9 -4.5 C -0.8 -3 -0.4 -1.5 0 0 Z" +
  '"/>';
